import Vue from 'vue';

import alice from '../../alice-api';

const CDT = {
  operation: 'eq',
  input: {
    type: 'parameter',
    field: '',
  },
  compareTo: '',
};

function extractConditionObject(array, mapObj, mode) {
  // console.log('TASK', array, mapObj);
  const conditionMap = mapObj;
  if (array) {
    for (let i = 0; i < array.length; i += 1) {
      if (array[i].type === 'condition') {
        // console.log('ADD cond', array[i].id);
        conditionMap[array[i].id] = array[i];
        for (let j = 0; j < array[i].if.length; j += 1) {
          extractConditionObject(array[i].if[j][mode], mapObj);
        }
        for (let k = 0; k < array[i].else.length; k += 1) {
          extractConditionObject(array[i].else[k][mode], mapObj);
        }
      }
    }
  }
  return true;
}

export default {
  namespaced: true,
  state: {
    selectedStoryBoardTab: 'info',
    selectedStoryBoardItem: {
      type: null,
      stateId: null,
      actionType: null,
      actionResult: null,
    },
    selectedSubHandlerTab: 'text',
    selectedProceedTab: null,
    // stateData: mockStateDataV2,
    stateData: {},
    selectedState: {},
    selectedTasksArray: [],
    selectedCondition: {},
    currentConditionMapStateId: '',
    currentConditionMap: {},
    selectedConditionIfIndex: 0,
  },
  getters: {
    selectedStoryBoardTab: (state) => state.selectedStoryBoardTab,
    selectedStoryBoardItem: (state) => state.selectedStoryBoardItem,
    selectedSubHandlerTab: (state) => state.selectedSubHandlerTab,
    selectedProceedTab: (state) => state.selectedProceedTab,
    selectedActionList: (state) => {
      if (state.selectedState.action) {
        if (state.selectedState.action[state.selectedSubHandlerTab]) {
          if (state.selectedSubHandlerTab === 'proceed') {
            if (state.selectedProceedTab !== '') {
              const sht = state.selectedSubHandlerTab;
              const spt = state.selectedProceedTab;
              const pt = state.selectedState.action[sht][spt];
              if (pt) {
                return pt;
              }
            }
          } else {
            return state.selectedState.action[state.selectedSubHandlerTab];
          }
        }
      }
      return null;
    },
    stateData: (state) => state.stateData,
    stateNameList: (state) => Object.keys(state.stateData),
    selectedState: (state) => state.selectedState,
    selectedStateAction: (state) => state.selectedState.action,
    selectedTasksArray: (state) => state.selectedTasksArray,
    selectedCondition: (state) => state.selectedCondition,
    currentConditionMap: (state) => state.currentConditionMap,
    selectedConditionIfIndex: (state) => state.selectedConditionIfIndex,
    selectedConditionIfArray: (state) => {
      if (state.selectedCondition) {
        if (state.selectedConditionIfIndex === -1) {
          return state.selectedCondition.else;
        } if (state.selectedConditionIfIndex > -1) {
          if (state.selectedCondition.if) {
            const sel = state.selectedCondition.if[state.selectedConditionIfIndex];
            if (sel && typeof sel.task !== 'undefined') {
              return sel.task;
            } if (sel && typeof sel.action !== 'undefined') {
              return sel.action;
            }
          }
        }
      }
      return [];
    },
    isValidStateAndCondition: (state) => (stateId, conditionId) => {
      const stateObj = state.stateData[stateId];
      if (stateObj) {
        let mode;
        let target;
        if (state.selectedStoryBoardTab === 'handler') {
          mode = 'action';
          const subTab = state.selectedSubHandlerTab;
          target = stateObj.action[subTab];
        } else {
          mode = 'task';
          target = stateObj.task;
        }
        const mapObj = {};
        extractConditionObject(target, mapObj, mode);
        // console.log(mapObj);
        if (typeof mapObj[conditionId] !== 'undefined') {
          return true;
        }
      }
      return false;
    },
  },
  actions: {
    loadStateData(context) {
      return new Promise((resolve, reject) => {
        alice.loadStateData().then((response) => {
          context.commit('setStateData', response.data.data);
          resolve(response.data.data);
        }).catch((error) => {
          reject(error);
        });
      });
    },
    updateState(context, stateData) {
      return new Promise((resolve, reject) => {
        if (stateData && stateData.stateId) {
          alice.updateState(stateData).then(() => {
            resolve();
          }).catch((error) => {
            reject(error);
          });
        } else {
          reject();
        }
      });
    },
    updateCurrentStateData(context) {
      const stateData = context.state.selectedState;
      context.dispatch('updateState', stateData);
    },
    updateStateDataById(context, stateId) {
      const stateData = context.state.stateData[stateId];
      context.dispatch('updateState', stateData);
    },
    addStateData(context, stateData) {
      return new Promise((resolve, reject) => {
        alice.addStateData(stateData).then(() => {
          resolve();
        }).catch((error) => {
          reject(error);
        });
      });
    },
    removeStateData(context, stateId) {
      return new Promise((resolve, reject) => {
        alice.removeStateData(stateId).then(() => {
          resolve();
        }).catch((error) => {
          reject(error);
        });
      });
    },
    setSelectedStoryBoardTab(context, params) {
      context.commit('setSelectedStoryBoardTab', params);
      context.commit('updateCurrentConditionMap');
    },
    setSelectedStoryBoardItem(context, params) {
      context.commit('setSelectedStoryBoardItem', params);
    },
    setSelectedSubHandlerTab(context, params) {
      context.commit('setSelectedSubHandlerTab', params);
      context.commit('updateCurrentConditionMap');
    },
    setSelectedProceedTab(context, params) {
      context.commit('setSelectedProceedTab', params);
    },
    setSelectedStateById(context, params) {
      context.commit('setSelectedStateById', params);
      context.commit('updateCurrentConditionMap');
      context.commit('setSelectedProceedTab', null);
    },
    updateCurrentStateAsSelectedTasksArray(context) {
      context.commit('updateCurrentStateAsSelectedTasksArray'); // params = arr[]
    },
    overrideArray(context, params) {
      context.commit('overrideArray', params);
    },
    overrideTaskArray(context, params) {
      context.commit('overrideTaskArray', params);
    },
    addTaskToArray(context, params) {
      if (params.taskData.type === 'condition') {
        context.commit('setToCurrentConditionMap', params);
      }
      context.commit('addTaskToArray', params);
      context.dispatch('updateCurrentStateData');
    },
    removeTaskFromArray(context, params) {
      const { taskArray, taskIndex } = params;
      if (taskArray[taskIndex].type === 'condition') {
        context.commit('removeFromCurrentConditionMap', params);
      }
      context.commit('removeTaskFromArray', params);
      context.dispatch('updateCurrentStateData');
    },
    setTaskArrayDataByIndex(context, params) {
      if (params.taskData.type === 'condition') {
        context.commit('setToCurrentConditionMap', params);
      }
      context.commit('setTaskArrayDataByIndex', params);
      context.dispatch('updateCurrentStateData');
    },
    addActionToArray(context, params) {
      context.commit('addActionToArray', params);
      context.dispatch('updateCurrentStateData');
    },
    removeActionFromArray(context, params) {
      context.commit('removeActionFromArray', params);
      context.dispatch('updateCurrentStateData');
    },
    setActionArrayDataByIndex(context, params) {
      context.commit('setActionArrayDataByIndex', params);
      context.dispatch('updateCurrentStateData');
    },
    overrideConditionIfArray(context, params) {
      context.commit('overrideConditionIfArray', params);
    },
    setSelectedConditionIfBlock(context, params) {
      context.commit('setSelectedConditionIfBlock', params);
    },
    setSelectedCondition(context, params) {
      context.commit('setSelectedConditionIfIndex', 0);
      context.commit('setSelectedCondition', params);
    },
    setSelectedConditionById(context, params) {
      context.commit('setSelectedConditionIfIndex', 0);
      context.commit('setSelectedConditionById', params);
    },
    setSelectedStateAndConditionById(context, params) {
      context.commit('setSelectedStateById', params);
      context.commit('updateCurrentConditionMap');
      context.commit('setSelectedConditionIfIndex', 0);
      context.commit('setSelectedConditionById', params);
    },
    addAndIf(context, params) {
      context.commit('addAndIf', params);
      context.dispatch('updateCurrentStateData');
    },
    removeAndIf(context, params) {
      context.commit('removeAndIf', params);
      context.dispatch('updateCurrentStateData');
    },
    addOrIf(context, params) {
      context.commit('addOrIf', params);
      context.dispatch('updateCurrentStateData');
    },
    addIfBlock(context, params) {
      context.commit('addIfBlock', params);
      context.dispatch('updateCurrentStateData');
    },
    removeIfBlock(context, params) {
      context.commit('removeIfBlock', params);
      context.dispatch('updateCurrentStateData');
    },
    setSelectedConditionIfIndex(context, params) {
      context.commit('setSelectedConditionIfIndex', params);
    },
    addTaskHandler(context, params) {
      context.commit('addTaskHandler', params);
      context.dispatch('updateCurrentStateData');
    },
    addProceedHandler(context, params) {
      context.commit('addProceedHandler', params);
      context.dispatch('updateCurrentStateData');
    },
    removeProceedHandler(context, params) {
      context.commit('removeProceedHandler', params);
      context.dispatch('updateCurrentStateData');
    },
    initCurrentHandlerTab(context, params) {
      context.commit('initCurrentHandlerTab', params);
      context.dispatch('updateCurrentStateData');
    },
    setStateObjectData(context, params) {
      context.commit('setStateObjectData', params);
      // if (context.state.selectedState) {
      //   context.dispatch('updateCurrentStateData');
      // } else {
      const { stateId } = params;
      context.dispatch('updateStateDataById', stateId);
      // }
    },
    removeStateById(context, params) {
      context.dispatch('removeStateData', params);
      context.commit('removeStateById', params);
      context.commit('resetDefaultOption');
    },
  },
  mutations: {
    resetDefaultOption(state) {
      const newState = state;
      newState.selectedStoryBoardTab = 'info';
      newState.selectedStoryBoardItem = {
        type: null,
        stateId: null,
        actionType: null,
        actionResult: null,
      };
      newState.selectedSubHandlerTab = 'text';
      newState.selectedProceedTab = null;
      newState.selectedState = {};
      newState.selectedTasksArray = [];
      newState.selectedCondition = {};
      newState.currentConditionMapStateId = '';
      newState.currentConditionMap = {};
      newState.selectedConditionIfIndex = 0;
    },
    setStateData(state, stateData) {
      const newState = state;
      newState.stateData = stateData;
    },
    setSelectedStoryBoardTab(state, tab) {
      const newState = state;
      newState.selectedStoryBoardTab = tab;
    },
    setSelectedStoryBoardItem(state, params) {
      const newState = state;
      newState.selectedStoryBoardItem = { ...params };
    },
    setSelectedSubHandlerTab(state, tab) {
      const newState = state;
      newState.selectedSubHandlerTab = tab;
    },
    setSelectedProceedTab(state, tab) {
      const newState = state;
      newState.selectedProceedTab = tab;
    },
    setSelectedStateById(state, params) {
      const newState = state;
      const { stateId } = params;
      newState.selectedState = newState.stateData[stateId];
    },
    overrideArray(state, params) {
      const newState = state;
      const { taskArray, actionArray, mode } = params;
      let arr;
      if (mode === 'task') {
        arr = taskArray;
        newState.selectedState.task = arr;
        newState.selectedTasksArray = newState.selectedState.task;
      } else if (mode === 'action') {
        arr = actionArray;
        const tab = newState.selectedSubHandlerTab;
        newState.selectedState.action[tab] = arr;
      } else if (mode === 'condition') {
        if (typeof taskArray !== 'undefined') {
          arr = taskArray;
        } else if (typeof actionArray !== 'undefined') {
          arr = actionArray;
        }
        if (newState.selectedCondition) {
          if (newState.selectedConditionIfIndex === -1) {
            newState.selectedCondition = arr;
          } else if (newState.selectedConditionIfIndex > -1) {
            if (newState.selectedCondition.if) {
              const sel = newState.selectedCondition.if[newState.selectedConditionIfIndex];
              if (typeof sel.task !== 'undefined') {
                sel.task = arr;
                // console.log('TOOGLE TASK', sel);
              } else if (typeof sel.action !== 'undefined') {
                sel.action = arr;
              }
            }
          }
        }
      }
    },
    overrideTaskArray(state, params) {
      const newState = state;
      const { taskArray, mode } = params;
      if (mode === 'task') {
        newState.selectedState.task = taskArray;
        newState.selectedTasksArray = newState.selectedState.task;
      } else if (mode === 'condition') {
        if (newState.selectedCondition) {
          if (newState.selectedConditionIfIndex === -1) {
            newState.selectedCondition = taskArray;
          } else if (newState.selectedConditionIfIndex > -1) {
            if (newState.selectedCondition.if) {
              const sel = newState.selectedCondition.if[newState.selectedConditionIfIndex];
              if (typeof sel.task !== 'undefined') {
                sel.task = taskArray;
                // console.log('TOOGLE TASK', sel);
              } else if (typeof sel.action !== 'undefined') {
                sel.action = taskArray;
              }
            }
          }
        }
      }
    },
    overrideActionArray(state, params) {
      const newState = state;
      const { actionArray, mode } = params;
      if (mode === 'action') {
        const tab = newState.selectedSubHandlerTab;
        newState.selectedState.action[tab] = actionArray;
      } else if (mode === 'condition') {
        if (newState.selectedCondition) {
          if (newState.selectedConditionIfIndex === -1) {
            newState.selectedCondition = actionArray;
          } else if (newState.selectedConditionIfIndex > -1) {
            if (newState.selectedCondition.if) {
              const sel = newState.selectedCondition.if[newState.selectedConditionIfIndex];
              if (typeof sel.task !== 'undefined') {
                sel.task = actionArray;
                // console.log('TOOGLE TASK', sel);
              } else if (typeof sel.action !== 'undefined') {
                sel.action = actionArray;
              }
            }
          }
        }
      }
    },
    addTaskToArray(state, params) {
      const { taskArray, taskData } = params;
      taskArray.push(taskData);
    },
    addActionToArray(state, params) {
      const { actionArray, actionData } = params;
      actionArray.push(actionData);
    },
    removeTaskFromArray(state, params) {
      const { taskArray, taskIndex } = params;
      taskArray.splice(taskIndex, 1);
    },
    removeActionFromArray(state, params) {
      const { actionArray, actionIndex } = params;
      actionArray.splice(actionIndex, 1);
    },
    updateCurrentStateAsSelectedTasksArray(state) {
      const newState = state;
      newState.selectedTasksArray = newState.selectedState.task;
    },
    overrideConditionIfArray(state, params) {
      const newState = state;
      const { conditionArray } = params;
      newState.selectedCondition.if = conditionArray;
    },
    setSelectedConditionIfBlock(state, params) {
      const newState = state;
      const { blockData, ifIndex } = params;
      if (ifIndex === -1) {
        newState.selectedCondition.else = blockData;
      } else if (ifIndex > -1) {
        newState.selectedCondition.if[ifIndex] = blockData;
      }
    },
    setSelectedCondition(state, params) {
      const newState = state;
      newState.selectedCondition = params.selectedCondition;
    },
    setSelectedConditionById(state, params) {
      const newState = state;
      const { conditionId } = params;
      if (newState.currentConditionMap[conditionId]) {
        newState.selectedCondition = newState.currentConditionMap[conditionId];
      } else {
        newState.selectedCondition = {};
      }
    },
    updateCurrentConditionMap(state) {
      const newState = state;
      if (newState.selectedState) {
        // Todo do update on change state, tab, sub-tab only
        // if (newState.currentConditionMapStateId !== newState.selectedState.stateId) {
        // console.log('- UPDATE CONDITION MAP');
        let mode;
        let target;
        if (newState.selectedStoryBoardTab === 'handler') {
          mode = 'action';
          const subTab = newState.selectedSubHandlerTab;
          target = newState.selectedState.action[subTab];
        } else {
          mode = 'task';
          target = newState.selectedState.task;
        }
        const mapObj = {};
        extractConditionObject(target, mapObj, mode);
        newState.currentConditionMap = mapObj;
        newState.currentConditionMapStateId = newState.selectedState.stateId;
        // }
      }
    },
    setToCurrentConditionMap(state, params) {
      const newState = state;
      const { taskData } = params;
      const { id } = taskData;
      newState.currentConditionMap[id] = taskData;
    },
    removeFromCurrentConditionMap(state, params) {
      const newState = state;
      const { taskArray, taskIndex } = params;
      const { id } = taskArray[taskIndex];
      delete newState.currentConditionMap[id];
    },
    addAndIf(state, params) {
      const newState = state;
      const { ifIndex, index, index2 } = params;
      newState.selectedCondition.if[ifIndex].condition[index].splice(index2 + 1, 0, { ...CDT });
    },
    removeAndIf(state, params) {
      const newState = state;
      const { ifIndex, index, index2 } = params;
      newState.selectedCondition.if[ifIndex].condition[index].splice(index2, 1);
      if (newState.selectedCondition.if[ifIndex].condition[index].length === 0) {
        newState.selectedCondition.if[ifIndex].condition.splice(index, 1);
      }
    },
    addOrIf(state, params) {
      const newState = state;
      const { ifIndex } = params;
      newState.selectedCondition.if[ifIndex].condition.push([{ ...CDT }]);
    },
    addIfBlock(state, params) {
      const newState = state;
      const { ifIndex, isAction } = params;
      if (isAction) {
        newState.selectedCondition.if.splice(ifIndex + 1, 0, {
          condition: [[{ ...CDT }]],
          action: [],
        });
      } else {
        newState.selectedCondition.if.splice(ifIndex + 1, 0, {
          condition: [[{ ...CDT }]],
          task: [],
        });
      }
    },
    removeIfBlock(state, params) {
      const newState = state;
      const { ifIndex } = params;
      newState.selectedCondition.if.splice(ifIndex, 1);
    },
    setSelectedConditionIfIndex(state, index) {
      const newState = state;
      newState.selectedConditionIfIndex = index;
    },
    setTaskArrayDataByIndex(state, params) {
      const { taskArray, taskIndex, taskData } = params;
      taskArray[taskIndex] = taskData;
    },
    setActionArrayDataByIndex(state, params) {
      const { actionArray, actionIndex, actionData } = params;
      actionArray[actionIndex] = actionData;
    },
    addTaskHandler(state, params) {
      const newState = state;
      const { actionType, actionData } = params;
      newState.selectedState.action[actionType].push(actionData);
    },
    addProceedHandler(state, params) {
      const newState = state;
      // Init proceed object if necessary
      // console.log('CH', newState.selectedState.action);
      if (typeof newState.selectedState.action.proceed === 'undefined') {
        // console.log('INIT PROCEED!!!');
        Vue.set(newState.selectedState.action, 'proceed', {});
        // newState.selectedState.action.proceed = {};
      }
      const { name } = params;
      const proceedName = `PROCEED_${name}`;
      newState.selectedState.action.proceed[proceedName] = [
        {
          type: 'action',
          action: {
            type: 'next',
            nextStateId: name,
          },
        },
      ];
    },
    removeProceedHandler(state, params) {
      const newState = state;
      const { name } = params;
      const proceedName = `PROCEED_${name}`;
      delete newState.selectedState.action.proceed[proceedName];
    },
    initCurrentHandlerTab(state) {
      const newState = state;
      const subTab = newState.selectedSubHandlerTab;
      Vue.set(newState.selectedState.action, subTab, []);
      // newState.selectedState.action[subTab] = [];
    },
    setStateObjectData(state, params) {
      const newState = state;
      const { stateId, stateObject } = params;
      Vue.set(newState.stateData, stateId, stateObject);
    },
    removeStateById(state, stateId) {
      const newState = state;
      newState.stateData[stateId] = undefined;
      delete newState.stateData[stateId];
    },
  },
};
